import SeparatorBar from 'pages/product-full-view/components/product-media-area/nutrition-label/components/SeparatorBar';
import { WrapperFactsPanel } from '../multiple-panel/facts-panel/overlay/WrapperNutrient';
import { isNil } from 'lodash';

const Calories = ({ label, compareValue, calories, caloriesFromFat }) => {
  if (isNil(calories)) return null;

  return (
    <div className='supplement-standard__text'>
      <WrapperFactsPanel
        label={['calories']}
        currentValue={label}
        originValue={compareValue}
      >
        <div className='supplement-standard__row'>
          <div
            style={{
              flex: 1,
            }}
          >
            Calories
          </div>
          <div className='supplement-standard__amountPerServing'>
            <p className='m-0'>{calories}</p>
          </div>
          <div className='supplement-standard__dv supplement-standard__dv--calories'></div>
        </div>
      </WrapperFactsPanel>
      <SeparatorBar />
      {!isNil(caloriesFromFat) ? (
        <>
          <WrapperFactsPanel
            label={['caloriesFromFat']}
            currentValue={label}
            originValue={compareValue}
          >
            <div className='supplement-standard__row'>
              <div
                style={{
                  flex: 1,
                  paddingLeft: '7px',
                }}
              >
                Calories from Fat
              </div>
              <div className='supplement-standard__amountPerServing'>
                <p className='m-0'>{caloriesFromFat}</p>
              </div>
              <div className='supplement-standard__dv supplement-standard__dv--calories'></div>
            </div>
          </WrapperFactsPanel>
          <SeparatorBar />
        </>
      ) : null}
    </div>
  );
};

export default Calories;
